import { css } from '@emotion/core';
export var line1 = {
  name: "1890djz",
  styles: "display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;"
};